import { EntityId, PaginationRequest } from '../common';

export interface IShipmentLocationRequest extends PaginationRequest {
  legalEntityId?: EntityId | string | number;
  shipmentLocationId?: EntityId | string;
  shipmentLocationTypeId?: string | number;
  shipmentLocationTypeCode?: string | number;
  shippingConditionId?: number;
  hasDocuments?: boolean;
  productLineId?: string | number;
  orderBlocked?: boolean;
  orderBy?: string;
  pointOfDeliveryId?: string | number;
}
